<template>
<div class="datebox" style="padding:10px">
    <v-date-picker
        v-model="picker"
        no-title
        color="#E13533"
        locale="jp-ja"
        :day-format="(date) => new Date(date).getDate()"
        year-icon="mdi-calendar-blank"
        prev-icon="mdi-skip-previous"
        next-icon="mdi-skip-next"
    ></v-date-picker>
    <div class="checkarea">
        <div class="checkrow">
            <v-checkbox
              v-model="selected"
              :label="category[index]"
              :color="color[index]"
              :value="category[index]"
              hide-details
              v-for="dat,index in category"
              :key = "index"
            ></v-checkbox>
        </div>
        <div class="checkrow">
            <v-checkbox
              v-model="selected_project"
              :label="project[index].text"
              color="#E13533"
              :value="dat.val"
              hide-details
              v-for="dat,index in project"
              :key="index"
            ></v-checkbox>
        </div>
    </div>
</div>
</template>
<script>
export default{
    props: ["project"],
    data () {
      return {
        inputPro : null,
        picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        color: ['#08415C','#42BFDD','#8380B6','#4FB477','#4A2040'],
        category: ['タスク','取材','イベント','プレスリリース','その他'],
        selected: ['タスク','取材','イベント','プレスリリース','その他'],
        selected_project : [],
      }
    },
    watch: {
        picker:  function (){
            this.$emit('date-select',{"selecteddate":this.picker});
        },
        project: function (){
            let tmp_project = [];
            for (var i = 0 ; i < this.project.length ; i++)
            {   
                tmp_project.push(this.project[i].val);
            }
            this.selected_project = tmp_project;
        },
        selected: function(){
            this.$emit('pick-status',{"cat":this.selected,"pro":this.selected_project});
        },
        selected_project: function(){
            this.$emit('pick-status',{"cat":this.selected,"pro":this.selected_project});
        },
    },
    created : function (){
    },
}
</script>
